/**
 * Returns react app stage version.
 */
export const reactAppStage = () => {
    const appStage =
        localStorage.getItem('REACT_APP_STAGE') ??
        import.meta.env.VITE_APP_STAGE ??
        'demo'
    switch (appStage) {
        case 'dev':
            return 'dev'
        case 'test':
            return 'test'
        case 'demo':
            return 'demo'
        case 'prod':
            return 'demo'
        case 'local':
            return 'local'
        default:
            return 'demo'
    }
}
